const axiosNotificationsAPI = 'https://typix-dev.azure-api.net/notification';

const axiosOfflineComparisonAPI = 'https://offline-comparison.ty-pix.ovh:60001';
const axiosTypixKeywordAPI = 'https://offline-comparison.ty-pix.ovh:60013';
const axiosPixOpAPI = 'http://137.74.200.56:8686';
const axiosPrivateAPI = 'https://typix-dev-api-connector.azuremicroservices.io';
const axiosBillingAPI = 'https://typix-dev.azure-api.net/billing';
const oldAxiosPrivateAPI = 'http://docker-dev.monetoring.com:9000/';
const axiosMonetoringAPI =
  'https://gateway-bg.aqisis.io/seo-topic-detection-upper-kwd-manager-link-typix/1.0';

const axiosAqisisFractalAPI =
  'https://gateway-bg.aqisis.io/seo-fractal-question-link-typix/1.0';

export const axiosSearchAIAPI =
  'https://gateway-bg.aqisis.io/typix-searchai-semantic/1.0';

export const axiosSearchAiOptimizationAPI =
  'https://search-ai-calculations.searchai-app.com:1012';

const axiosAiTokenValidationAPI =
  'https://ai-token-validation-service.mangodesert-d5246498.francecentral.azurecontainerapps.io/api';

const animationUrl =
  'https://animationcloud.blob.core.windows.net/animation-container';
const axiosAqisisAPI = 'https://gateway-bg.aqisis.io';

export {
  axiosNotificationsAPI,
  axiosOfflineComparisonAPI,
  axiosTypixKeywordAPI,
  axiosPixOpAPI,
  axiosPrivateAPI,
  axiosBillingAPI,
  oldAxiosPrivateAPI,
  axiosMonetoringAPI,
  axiosAqisisFractalAPI,
  animationUrl,
  axiosAqisisAPI,
  axiosAiTokenValidationAPI,
};
